export const WELCOME = `# Welcome to md

Paste markdown on the left, preview on the right.

## Math

Inline: $E = mc^2$

Block:
$$\\int_0^1 x^2 \\, dx = \\frac{1}{3}$$

## Code

\`\`\`js
console.log('Hello, world');
\`\`\`

## Diagram

\`\`\`mermaid
graph LR
  A[Edit] --> B[Preview]
  B --> C[Share or export]
\`\`\`

## Callout

> [!TIP]
> Use **Edit** and **Preview** in the header to switch views.

## Table

| Action | Shortcut |
| --- | --- |
| Command palette | Ctrl+K |
| Share | Ctrl+Shift+S |
`
